/**
 * Registers the offline icon bundle into @iconify/react's storage so <Icon>
 * resolves glyphs from memory instead of fetching api.iconify.design at
 * runtime. Required under our CSP (connect-src omits the Iconify CDN) and for
 * offline + Capacitor native use.
 *
 * Source: src/generated/icon-bundle.json, generated by
 * scripts/build-icon-bundle.mjs (run via `npm run icons:bundle`). Regenerate
 * and commit when adding icons; CI fails if the committed bundle is stale.
 */
import { addCollection } from '@iconify/react';
import bundle from '@/generated/icon-bundle.json';

type IconCollection = Parameters<typeof addCollection>[0];

let registered = false;

export function registerBundledIcons(): void {
  if (registered) return;
  for (const collection of bundle as unknown as IconCollection[]) {
    addCollection(collection);
  }
  registered = true;
}
